import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core/styles';
import PartnersCard from './_partners_card';
import { partners } from './__data';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(0),
    backgroundColor: 'transparent'
  },
  paperTitle: {
    padding: theme.spacing(4),
    background: 'transparent',
    boxShadow: 'none'
  },
  section: {
    paddingTop: '5rem',
  }
}));

const Partners = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        className={classes.section}
        component="section"
        xs={12}
      >
        <Paper
          className={classes.paperTitle}
          component="header"
        >
          <Typography
            align="center"
            component="h2"
            variant="h1"
          >
            Les associations partenaires
          </Typography>
          <Typography
            align="center"
            component="p"
            variant="body2"
          >
            Ils sont prêts à planter vos arbres !
          </Typography>
        </Paper>
        <Grid
          container
          style={{backgroundColor: 'white', paddingBottom: '5rem'}}
          xs={12}
        >
          {partners.map((partner, index) => {
            return (
              <Grid
                component="article"
                item
                key={`partner-${index}`}
                md={4}
                sm={12}
                xs={12}
              >
                <Paper
                  className={classes.paper}
                  elevation={0}
                >
                  <PartnersCard partner={partner}/>
                </Paper>
              </Grid>
            )
          })}
        </Grid>
      </Grid>

    </>
  );
}

export default Partners;
